import { Checkbox, Input, Page, Text } from "@geist-ui/core";
import React, { useEffect, useState } from "react";
import ValueItem from "../../../Components/ValueItem";
import { v4 as uuidv4 } from "uuid";
import "./styles.css";

function Question(props) {
  const { data, options, selectedValues, nameValue, emailValue, onNameChange, onEmailChange } = props;
  const [checked, setChecked] = useState([]);
  const [mountStyle, setMountStyle] = useState({
    opacity: 0,
    transition: "all 1s ease",
  });

  //console.log(mountStyle, data.question);

  useEffect(() => {
    setChecked(selectedValues);

    return null;
  }, [selectedValues]);

  useEffect(() => {
    setMountStyle({
      opacity: 1,
      transition: "all 1s ease",
    });

    return () => {
      setMountStyle({
        opacity: 0,
        transition: "all 1s ease",
      });
    };
  }, []);

  const handleOnChange = (val) => {
    //console.log(val, "this is the onChange EventValue");
    ////console.log(val, data.question, "IT AINT ME");
    setChecked(val);
    props.onChange(val);
  };

  /* const isDisabled = (val) => {
      //console.log(checked, selectedValues, 'checked Items & Selected Values')
    //It will return -1 if the item was not found in the checked array array.
    //It will also check if you've reached the max choice number
    return selectedValues.length === data.choiceLimit && selectedValues.indexOf(val) === -1;
  }; */

  const renderCheckboxes = () => {
    return options.map((item, index) => {
      //const key= uuidv4();
      const isDisabled =
        checked.length === data.choiceLimit && checked.indexOf(item) === -1;
      return <ValueItem key={data.uid} isDisabled={isDisabled} data={item} />;
    });
  };

  const renderContent = () => {
    //console.log(data, "this is the question data");
    console.log(data.type);
    switch (data.type) {
      case "question":
        return (
          <div className="checkboxGroup">
            <Checkbox.Group value={selectedValues} onChange={handleOnChange}>
              {renderCheckboxes()}
            </Checkbox.Group>
          </div>
        );
      case "form":
        return (
          <div className="inputContainer">
            <input
              className={'nameInput'}
              value={nameValue}
              onChange={onNameChange}
              type={"text"}
              placeholder="Full Name"
              width="100%"
            />
            <input
              value={emailValue}
              onChange={onEmailChange}
              type={"email"}
              placeholder="Email"
              width="100%"
            />
          </div>
        );
      case "newSection":
      default:
        return null;
    }
  };

  return (
    <div id="question" style={mountStyle}>
      {renderContent()}
    </div>
  );
}

export default Question;
